import clsx from 'clsx';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { TPersonalLicense } from '@/core/infra';
import s from './PersonalLicenseDetails.module.scss';
import moment from 'moment';

type PersonalLicenseDetailsProps = {
  license: TPersonalLicense;
  className?: string;
};

export const PersonalLicenseDetails: FC<PersonalLicenseDetailsProps> = (props) => {
  const { license, className } = props;
  const { licenseStatus } = license;
  const { t } = useTranslation();

  const isExpired = useMemo(() => {
    return licenseStatus !== 'ACTIVE' && licenseStatus !== 'INACTIVE';
  }, [licenseStatus]);

  const getExpirationDate = (license: TPersonalLicense) => {
    const { expirationDate, productId } = license;

    if (!expirationDate) {
      return '';
    }

    if (productId === 6) {
      return t('prices_subscription_TigerXLT').toLowerCase();
    }

    const currentDate = moment(new Date());
    const expDate = moment(expirationDate);
    const difference = moment.duration(expDate.diff(currentDate));
    const days = Math.ceil(difference.asDays());
    const date = moment(expirationDate).format('DD MMM YYYY');

    if (days > 30) {
      return `${t('personal-license_expiration-expired').toLowerCase()} ${date}`;
    }

    if (days >= 0) {
      return `${days} ${t('personal-license_expiration-days-left')}`;
    }

    return date;
  };

  return (
    <div className={clsx(s.root, className)}>
      <div className={clsx(s.status, { [s.expired]: isExpired })}>
        {isExpired ? t('personal-license_status-expired') : t('personal-license_status-active')}
      </div>
      <div className={s.date}>{getExpirationDate(license)}</div>
    </div>
  );
};
